var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9248 0.313102L7.05914 4.9183L2.19349 0.313102C1.71042 -0.144104 1.01197 -0.0967056 0.4549 0.43013C-0.102175 0.957386 -0.152254 1.61887 0.330367 2.07607L5.19602 6.68127L0.354298 11.2638C-0.127436 11.7198 -0.0848912 12.4215 0.4549 12.9324C0.994691 13.4433 1.73569 13.4827 2.21742 13.0272L7.05914 8.44466L11.9009 13.0272C12.3826 13.4832 13.124 13.4429 13.6638 12.932C14.2036 12.4211 14.2453 11.7198 13.764 11.2638L8.92226 6.68127L13.7879 2.07607C14.271 1.61887 14.2209 0.957805 13.6643 0.43055C13.1076 -0.0967058 12.4083 -0.144104 11.9252 0.312683L11.9248 0.313102Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.8970a3fc16e3e7587367d35271050ccc.svg";
export { ForwardRef as ReactComponent };